/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/


export function handleScrollWhenInputIsFocused(e) {

  const elementField = e.target.getBoundingClientRect();
  const footerHeight = 40;

  if (
    elementField.bottom > window.innerHeight - footerHeight ||
    elementField.top < footerHeight
  ) {
    e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}